var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
export default class ApiService extends React.Component {
    constructor(context) {
        super(context);
        this.authContext = context.authContext;
        this.pluginContext = context.pluginContext;
        this.pageContext = context.pageContext;
        this.basePath = this.pageContext.basePath || '';
    }
    getNode(nodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const nodes = yield this.getNodes([nodeId]);
                return nodes.pop();
            }
            catch (e) {
                return null;
            }
        });
    }
    getNodes(uids) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const url = '?type=1611744861&action=nodes' +
                '&nodes=' +
                uids.join(',') +
                '&customer=' +
                ((_b = (_a = this.authContext) === null || _a === void 0 ? void 0 : _a.knowledgebase.customer) !== null && _b !== void 0 ? _b : '') +
                '&token=' +
                ((_d = (_c = this.authContext) === null || _c === void 0 ? void 0 : _c.knowledgebase.token) !== null && _d !== void 0 ? _d : '') +
                '&language=' +
                this.pageContext.language;
            return this._call(url);
        });
    }
    refreshToken() {
        const url = '?type=1611744861&action=refreshToken' +
            '&customer=' +
            this.authContext.knowledgebase.customer +
            '&token=' +
            this.authContext.knowledgebase.token +
            '&language=' +
            this.pageContext.language;
        return this._call(url);
    }
    search(searchText, startNodeUid) {
        const url = '?type=1611744861&action=search' +
            '&keywords=' +
            encodeURIComponent(searchText) +
            '&customer=' +
            this.authContext.knowledgebase.customer +
            '&token=' +
            this.authContext.knowledgebase.token +
            '&startNodeUid=' +
            startNodeUid;
        return this._call(url);
    }
    getBreadcrumb(uid, withSubnodes = false) {
        return this.getBreadcrumbs([uid], withSubnodes).then((breadcrumbs) => {
            return breadcrumbs.pop() || [];
        });
    }
    getBreadcrumbs(uids, withSubnodes) {
        const url = '?type=1611744861&action=breadcrumb' +
            '&nodes=' +
            uids.join(',') +
            '&customer=' +
            this.authContext.knowledgebase.customer +
            '&token=' +
            this.authContext.knowledgebase.token +
            '&language=' +
            this.pageContext.language;
        +'&withSubnodes=' + (withSubnodes ? 1 : 0);
        return this._call(url);
    }
    logNodeView(nodeId) {
        var _a, _b, _c, _d;
        const url = '?type=1611744861&action=logNodeView' +
            '&customer=' +
            ((_b = (_a = this.authContext) === null || _a === void 0 ? void 0 : _a.knowledgebase.customer) !== null && _b !== void 0 ? _b : '') +
            '&token=' +
            ((_d = (_c = this.authContext) === null || _c === void 0 ? void 0 : _c.knowledgebase.token) !== null && _d !== void 0 ? _d : '') +
            '&nodeId=' +
            nodeId;
        return this._call(url);
    }
    _call(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
                redirect: 'follow',
                referrer: 'no-referrer',
            })
                .then((response) => {
                return response.json();
            })
                .catch((err) => {
                console.error(err);
            });
        });
    }
}
